exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".specs-product-name small {\n  color: inherit !important;\n  font-size: inherit !important;\n  font-weight: inherit !important;\n}", ""]);

// exports
